import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { workplaceService } from '@api/services/services';
import { WorkplaceDto } from '@api/models/workplace/WorkplaceDto';
import { EntityState } from '@api/models/enums/EntityState';

type State = BaseType<WorkplaceDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsWorkplaceSlice = baseSlice({
  name: 'optionsWorkplace',
  initialState,
});

export const selectOptionsWorkplaceState = (state: RootState) => state.optionsWorkplace.state;
export const selectOptionsWorkplace = (state: RootState) => state.optionsWorkplace.data;
export const optionsWorkplaceActions = optionsWorkplaceSlice.actions;

export const getOptionsWorkplace =
  (search: string | undefined, establishments: string[] | undefined, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
    const handleGetData = async () => {
      const response = await workplaceService.query(
        {
          q: search,
          state: EntityState.Active,
          nameOnly: true,
          establishments: establishments,
          page: 0,
          size: AUTOCOMPLETE_MAX_ITEMS,
          sort: ['name', 'asc'],
        },
        { cancelToken: cancelToken as any }
      );
      return { data: response.data.content ?? [] };
    };

    getItem({
      dispatch,
      actions: optionsWorkplaceActions,
      getData: handleGetData,
    });
  };
